import React, { useState, useEffect } from 'react';
import './coursesProgressPage.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical, faTrash, faRotateRight, faBookOpen } from '@fortawesome/free-solid-svg-icons';

import bazeleconta from '../imagesHome/bazeleconta.png';
import contafinanciara from '../imagesHome/contafinanciara.png';

const apiUrl = process.env.REACT_APP_API_URL;

const CoursesProgressPage = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [menuOpen, setMenuOpen] = useState(null);

  useEffect(() => {
    const fetchCourseProgress = async () => {
      try {
        const response = await fetch(`${apiUrl}/user/progress`, {
          credentials: 'include',
        });
        
        if (response.ok) {
          const data = await response.json();
          const startedCourses = data.filter(course => course.progress > 0);
          setCourses(startedCourses);
        }
      } catch (error) {
        console.error('Error fetching course progress:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourseProgress();
  }, []);

  const getCourseImage = (courseName) => {
    if (courseName.includes('Bazele') || courseName.includes('bazele')) {
      return bazeleconta;
    } else if (courseName.includes('Financiar') || courseName.includes('financiar')) {
      return contafinanciara;
    }
    return bazeleconta;
  };

  const toggleMenu = (index) => {
    setMenuOpen(menuOpen === index ? null : index);
  };

  const handleDelete = async (courseId) => {
    if (window.confirm('Sigur vrei să ștergi progresul acestui curs?')) {
      try {
        const response = await fetch(`${apiUrl}/user/progress/${courseId}`, {
          method: 'DELETE',
          credentials: 'include',
        });
        
        if (response.ok) {
          setCourses(courses.filter(course => course.id !== courseId));
        }
      } catch (error) {
        console.error('Error deleting course:', error);
      }
    }
    setMenuOpen(null);
  };

  const handleRestart = async (courseId) => {
    if (window.confirm('Sigur vrei să reîncepi acest curs de la zero?')) {
      try {
        const response = await fetch(`${apiUrl}/user/progress/${courseId}/restart`, {
          method: 'POST',
          credentials: 'include',
        });
        
        if (response.ok) {
          // Refresh the courses list
          const refreshResponse = await fetch(`${apiUrl}/user/progress`, {
            credentials: 'include',
          });
          const data = await refreshResponse.json();
          const startedCourses = data.filter(course => course.progress > 0);
          setCourses(startedCourses);
        }
      } catch (error) {
        console.error('Error restarting course:', error);
      }
    }
    setMenuOpen(null);
  };

  if (loading) {
    return (
      <div className="courses-progress-page">
        <div className="progress-page-header">
          <h1>Progresul Cursurilor</h1>
        </div>
        <div className="progress-page-content">
          <p className="loading-message">Se încarcă...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="courses-progress-page">
      <div className="progress-page-header">
        <h1>Progresul Cursurilor</h1>
        <Link to="/userpage" className="back-link">Înapoi la profil</Link>
      </div>

      <div className="progress-page-content">
        {courses.length === 0 ? (
          <div className="progress-empty-state">
            <div className="empty-icon-large">
              <FontAwesomeIcon icon={faBookOpen} />
            </div>
            <h2>Nu ai cursuri în progres</h2>
            <p>Începe să înveți pentru a vedea progresul tău aici</p>
            <Link to="/cursuri" className="btn-browse-courses">
              Explorează cursurile
            </Link>
          </div>
        ) : (
          <div className="progress-courses-list">
            {courses.map((course, index) => (
              <div key={index} className="progress-course-item">
                <div className="course-item-icon">
                  <img src={getCourseImage(course.course_name)} alt={course.course_name} />
                </div>
                
                <div className="course-item-info">
                  <h3 className="course-item-title">{course.course_name}</h3>
                  <p className="course-item-status">În progres</p>
                  
                  <div className="course-progress-bar">
                    <div 
                      className="course-progress-fill" 
                      style={{ width: `${course.progress}%` }}
                    ></div>
                  </div>
                  <span className="course-progress-text">{course.progress}% completat</span>
                </div>

                <div className="course-item-actions">
                  <button 
                    className="menu-toggle-btn"
                    onClick={() => toggleMenu(index)}
                  >
                    <FontAwesomeIcon icon={faEllipsisVertical} />
                  </button>

                  {menuOpen === index && (
                    <div className="course-actions-menu">
                      <button 
                        className="action-menu-item delete"
                        onClick={() => handleDelete(course.id)}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                        <span>Delete</span>
                      </button>
                      <button 
                        className="action-menu-item restart"
                        onClick={() => handleRestart(course.id)}
                      >
                        <FontAwesomeIcon icon={faRotateRight} />
                        <span>Restart course</span>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CoursesProgressPage;
